import React, { useState, useEffect } from "react";
import "./CardTabs.scss";
import { useSelector } from "react-redux";
import {
    Box,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import BaseCard from "../UI/BaseCard/BaseCard";
import CustomFormNew from "../UI/CustomFormNew/CustomFormNew";
import CustomAlert from "../UI/CustomAlert/CustomAlert";

function PreAuthPaymentModal({ open, handleClose, handleSubmit, alertPreAuth, setAlertPreAuth, selectedHiddenCardNo }) {
    const [formValues, setFormValues] = useState({});

    return (
        <>
            <BaseDrawer
                open={open}
                handleClose={handleClose}
                height="80vh"
                title={"Make Pre Auth Payment"}
            >
                <BaseCard>
                <Box className="cardtabs-container pt-0 pb-0">
                        MasterCard - {selectedHiddenCardNo}
                </Box>
                    <Box className="cardtabs-container">
                        <Box>
                            <CustomFormNew 
                                formValues={formValues}
                                formName={"preauthpayment"}
                                buttonText={"Submit"}
                                onSubmit={handleSubmit}
                                loadingButtonText={"Adding Card ..."}
                            />

                            <CustomAlert
                                severity={alertPreAuth?.severity} 
                                show={alertPreAuth?.showAlert} 
                                header={alertPreAuth?.header} 
                                message={alertPreAuth?.message} 
                                onClick={(prevDetails) => {
                                    setAlertPreAuth({...prevDetails, showAlert: false});
                                }}
                                autoclose={alertPreAuth?.severity === "error" ? false : true}
                            />
                        </Box>
                    </Box>
                </BaseCard>
            </BaseDrawer>
        </>
    )
}

export default PreAuthPaymentModal;
